export default __webpack_public_path__ + "static/livro-de-reclamacoes-3092621d604567cb9dcdd6568448131f.png";